module.exports = __webpack_public_path__ + "img/logo.bb9c2367.png";